// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const UploadScreenshot = CreateProcess({
	method: "POST",
	name: "UploadScreenshot",
	type: "BUGS:UPLOADSCREENSHOT",

	request: (props) => ({
		url: "/bug-report/screenshot/",
		payload: props.payload,
	}),

	success: (response) => ({
		fileName: response.data.file,
	}),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});

export const GetPresignedPost = CreateProcess({
	method: "POST",
	name: "GetPresignedPostScreenshot",
	type: "BUGS:UPLOADS.GETURL",

	request: () => ({
		url: "/bug-report/signed-post/",
	}),

	success: (response) => fromJS(response),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});

export const CreateBugReport = CreateProcess({
	method: "POST",
	name: "CreateBugReport",
	type: "BUGS:REPORT.CREATE",

	request: (props) => ({
		url: "/bug-report/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response),
	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});

export const GetBugReport = CreateProcess({
	method: "GET",
	name: "GetBugReport",
	type: "BUGS:REPORT.GET",

	request: (props) => ({
		url: `/bug-report/${props.reportID}`,
	}),

	success: (response) => fromJS(response),
	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});
